var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useIsMobile } from '../../App/hooks/useIsMobile';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
function Shortcuts() {
    var isMobile = useIsMobile();
    var shortcuts = [
        {
            id: 1,
            label: 'Escola Hub',
            link: 'https://supercomm.notion.site/1c999a72728481b29455c31edf33ba7b',
            type: 'external',
            icon: SchoolOutlinedIcon,
            mobileStyle: { order: 2, flex: '1 1 0', padding: '0' },
        },
        {
            id: 2,
            label: 'Materiais de Divulgação',
            link: 'https://supercomm.notion.site/Acervo-para-provedores-24d99a7272848044bff0c4aade98861b',
            type: 'external',
            icon: InstagramIcon,
            mobileStyle: { order: 1, flex: '1 1 100%' },
        },
        {
            id: 3,
            label: 'Pagar Faturas',
            link: '/billings',
            type: 'internal',
            icon: RequestQuoteOutlinedIcon,
            mobileStyle: { order: 3, flex: '1 1 0', padding: '0', marginLeft: '-7px' },
        },
        {
            id: 4,
            label: 'Meus Assinantes',
            link: '/subscribers',
            type: 'internal',
            icon: Groups2OutlinedIcon,
            mobileStyle: { order: 5, flex: '1 1 100%' },
        },
        {
            id: 5,
            label: 'Aprovação de Artes',
            link: '/upload_arts',
            type: 'internal',
            icon: CheckBoxOutlinedIcon,
            mobileStyle: { order: 4, flex: '1 1 100%' },
        },
    ];
    return (_jsx("div", __assign({ className: "container-shortcuts" }, { children: shortcuts.map(function (shortcut) {
            return shortcut.type === 'internal' ? (_jsx(Link, __assign({ to: shortcut.link, className: "shortcut-card", style: isMobile ? shortcut.mobileStyle : {} }, { children: _jsxs("span", { children: [_jsx(shortcut.icon, {}), " ", _jsx("span", { children: shortcut.label })] }) }), shortcut.id)) : (_jsx("a", __assign({ href: shortcut.link, target: "_blank", className: "shortcut-card", style: isMobile ? shortcut.mobileStyle : {} }, { children: _jsxs("span", __assign({ style: isMobile && shortcut.id === 3 ? { gap: '2px' } : {} }, { children: [_jsx(shortcut.icon, {}), " ", _jsx("span", { children: shortcut.label })] })) }), shortcut.id));
        }) })));
}
export default Shortcuts;
